var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpConcat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.458333 26.458334",
    height: 100,
    width: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#b9b9b9",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#b9b9b9",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z ",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.4)",
    style: {
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#6a6a6a",
      fillOpacity: 1
    },
    d: "M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    refX: 0,
    refY: 0,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(0.2) rotate(180) translate(6,0)",
    style: {
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: "1pt",
      strokeOpacity: 1,
      fill: "#000000",
      fillOpacity: 1
    },
    d: "M 0.0,0.0 L 5.0,-5.0 L -12.5,0.0 L 5.0,5.0 L 0.0,0.0 z "
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  })), /*#__PURE__*/React.createElement("marker", {
    orient: "auto",
    refY: 0,
    refX: 0,
    style: {
      overflow: "visible"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.77,0 -2.88,5 V -5 Z",
    style: {
      fill: "#6a6a6a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#6a6a6a",
      strokeWidth: "1.00000003pt",
      strokeOpacity: 1
    },
    transform: "scale(-0.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-270.54165)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.01146239,-0.04557762)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 270.79889,
    x: 0.20020707,
    height: 10.424556,
    width: 10.530414,
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 0.67647177,
    y: 276.24933
  }), /*#__PURE__*/React.createElement("rect", {
    y: 276.24933,
    x: 5.6506233,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 271.27515,
    x: 0.67647177,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 5.6506233,
    y: 271.27515
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 10.212916,
    height: 10.107058,
    x: 0.51770431,
    y: 271.11639,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.7787945,-0.33615999)"
  }, /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 291.3566,
    x: 1.9904644,
    height: 5.450376,
    width: 10.42457,
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 291.83286,
    x: 2.4667289,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 7.4408808,
    y: 291.83286
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 10.107075,
    height: 5.132874,
    x: 2.3079612,
    y: 291.6741,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.6737423,-0.6198402)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#e9e9e9",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 10.424565,
    height: 15.398736,
    x: 17.178343,
    y: 276.53253,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 17.654602,
    y: 286.95715
  }), /*#__PURE__*/React.createElement("rect", {
    y: 286.95715,
    x: 22.628754,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 281.98297,
    x: 17.654602,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 22.628754,
    y: 281.98297
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    width: 4.9741549,
    height: 4.9741149,
    x: 17.654602,
    y: 277.00879
  }), /*#__PURE__*/React.createElement("rect", {
    y: 277.00879,
    x: 22.628754,
    height: 4.9741149,
    width: 4.9741549,
    style: {
      opacity: 1,
      fill: "#ddd4d4",
      fillOpacity: 0,
      stroke: "#909090",
      strokeWidth: 0.5291667,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    ry: 0,
    y: 276.85004,
    x: 17.49584,
    height: 15.081241,
    width: 10.107069,
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#6a6a6a",
      strokeWidth: 1.0583334,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.4396584,2.4870883)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291663,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 13.229167,285.78456 v -4.02748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.215427,283.77082 h 4.02748",
    style: {
      fill: "none",
      stroke: "#b9b9b9",
      strokeWidth: 1.32291663,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-0.02844325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.981458,273.98123 c 0,-1.01961 0.381174,-2.11666 -1.545793,-2.11666 h -7.087861",
    style: {
      fill: "none",
      stroke: "#6a6a6a",
      strokeWidth: 0.79374999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#marker10165)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 20.981458,293.6173 c 0,1.01961 0.381174,2.11665 -1.545793,2.11665 h -7.087861",
    style: {
      fill: "none",
      stroke: "#6a6a6a",
      strokeWidth: 0.79374999,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      markerStart: "url(#marker10165-3)"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpConcat);
export default __webpack_public_path__ + "static/media/op-concat.730b3eec012e3fb1cdac002883f0502a.svg";
export { ForwardRef as ReactComponent };